export default "__VITE_ASSET__D_ga4rBl__"